module.exports = __webpack_public_path__ + "img/border_rectangle4.42ac5883.svg";